import { PaymentProviderListType } from "../../../common/types";



type Props = {
    paymentProviderList: Array<PaymentProviderListType>,
    selectedPaymentProvider?: number,
    onSelect: (item: PaymentProviderListType) => void,
    show: boolean
}
const PaymentProviderSelectBox = (props: Props) => {

    const { paymentProviderList, selectedPaymentProvider, onSelect, show } = props;


    const getEmptyListView = () => {

        return (
            <div className="items-center justify-center flex mt-5 text-lg mb-5">
                Herhangi bir kayıt bulunamadı.
            </div>
        );
    }

    if (!show) {
        return null;
    }

    return (
        <div id="select-content" className={`!max-h-[320px] custom-dropdownmodal border border-t-0 border-light-border shadow-lg rounded-b-2xl px-4`}>

            {paymentProviderList.length == 0 ? getEmptyListView() : paymentProviderList?.map((item, index) => {

                return (
                    <div
                        className={`flex flex-col justify-between px-2 mb-2 py-2 cursor-pointer  border-gray-200 border-b-2  bg-light-gray-2 
                     border-transparent border-2 hover:border-blue-700 rounded-md  
                                 ${selectedPaymentProvider == item.vpid && "!border-blue-700 !border-2"} 
                                 `}
                        key={index + "customerList"}
                        onClick={() => onSelect(item)}
                    >
                        <div className="flex items-center">
                            <img src={"/" + item.bankImagePath} alt="" className="w-[50px]" />

                            <label className="ml-2 text-[13px]">
                                {item.vpdisplayname}
                            </label>
                        </div>

                    </div>
                );
            })}


        </div>
    );
}
export default PaymentProviderSelectBox;